<template>
  <div>Dashboard content</div>
</template>

<script>
export default {
  name: 'StudentDashboardContent'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Student/StudentDashboardContent.vue